import React, { Component } from "react";
import './Footer.css';

export class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <p className="copyText">Portfolio Website &copy; 2024 | Arghya Bhattacharjee | All rights reserved</p>
        <p>Designed and developed by Arghya Bhattacharjee</p>
      </footer>
    );
  }
}

export default Footer;
